module.exports = __webpack_public_path__ + "static/media/actividadcolor.cc190a59.png";